import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { deleteUserProfilePictureThunk } from '../thunks/user-profile.thunk'

export type DeleteUserProfilePictureState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
}

export const initialState: DeleteUserProfilePictureState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
}

const deleteUserProfilePictureSlice = createSlice({
  name: 'deleteUserProfilePictureSlice',
  initialState: initialState,
  reducers: {
    resetDeleteUserProfilePictureState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteUserProfilePictureThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .addCase(deleteUserProfilePictureThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED

        // state.requestResponse.data = action.payload.description
      })
      .addCase(deleteUserProfilePictureThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetDeleteUserProfilePictureState } = deleteUserProfilePictureSlice.actions
export default deleteUserProfilePictureSlice.reducer
